import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Umami Analytics — fest auf die selbst gehostete Instanz verdrahtet (data-domains verhindert Dev-Tracking)
const umamiUrl = 'https://umami.gsk-it.de';
const umamiWebsiteId = '71f6237d-bf19-48fc-91fd-a27a71430e05';
if (umamiUrl && umamiWebsiteId) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = `${umamiUrl}/script.js`;
  script.dataset.websiteId = umamiWebsiteId;
  script.dataset.domains = 'energie.wisogreen.de';
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
